import * as React from 'react';
import IntersectionObserver from 'react-intersection-observer';
import {NOOP} from 'components/UIKit/utilities';
import {ImageOptions} from 'components/UIKit/Picture';
import {ListingImage} from '../ListingImage';
import {ShopScreenShot} from '../../../../types';

export interface ListingThumbnailProps {
  alt?: string;
  index: number;
  image: ShopScreenShot;
  active: boolean;
  container: React.RefObject<HTMLElement>;
  onClick: (id: string) => any;
  onVisibilityChange: (instance: ListingThumbnail, inView: boolean) => any;
}

const thumbnailImageOptions: ImageOptions[] = [
  {
    breakpoint: {
      min: 0,
      max: null,
    },
    options: {
      format: 'jpg',
      width: 94,
      height: 60,
    },
  },
];

export class ListingThumbnail extends React.Component<ListingThumbnailProps> {
  wrapper: React.RefObject<any> = React.createRef();

  handleViewportChange = (inView) => {
    const {onVisibilityChange = NOOP} = this.props;
    onVisibilityChange(this, inView);
  };

  render() {
    const {alt, index, image, active, container, onClick} = this.props;

    return (
      <IntersectionObserver
        tag="li"
        ref={this.wrapper}
        root={container.current}
        threshold={1}
        onChange={this.handleViewportChange}
      >
        <ListingImage
          id={image.id}
          alt={alt}
          type="thumbnail"
          index={index}
          active={active}
          imageUrl={image.url}
          imageOptions={thumbnailImageOptions}
          onClick={onClick}
        />
      </IntersectionObserver>
    );
  }
}
